import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import type { BlogPost } from '../types/blog';

export function useBlogPost(slug: string | undefined) {
  const [post, setPost] = useState<BlogPost | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchPost() {
      if (!slug) {
        setError('Blog post slug is required');
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const { data, error: fetchError } = await supabase
          .from('blog_posts')
          .select(`
            *,
            plants:blog_post_plants(
              plant:plants(
                id,
                name,
                scientific_name,
                image_url
              )
            )
          `)
          .eq('slug', slug)
          .eq('published', true)
          .single();

        if (fetchError) throw fetchError;

        // Transform the plants data structure
        const transformedPost = {
          ...data,
          plants: data.plants?.map((item: any) => item.plant) || []
        };

        setPost(transformedPost);
      } catch (err) {
        console.error('Error fetching blog post:', err);
        setError(err instanceof Error ? err.message : 'An error occurred');
      } finally {
        setLoading(false);
      }
    }

    fetchPost();
  }, [slug]);

  return { post, loading, error };
}